import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MatFormFieldControl } from "@angular/material/form-field";
import { importLibrary } from "@googlemaps/js-api-loader";

const DEFAULT_STREET_ADDRESS_FORM_FIELD_NAME = "address"
const DEFAULT_AUTOCOMPLETION_RESPONSE_TIME_IN_MS = 150

@Component({
  selector: 'app-street-address-autocomplete-field',
  templateUrl: './autocomplete-street-address-field.component.html',
  styleUrls: ['./autocomplete-street-address-field.component.css'],
  providers: [
      {
	    provide: MatFormFieldControl,
	    useExisting: AutocompleteStreetAddressComponent,
	  },
	],
})
export class AutocompleteStreetAddressComponent implements OnInit, AfterViewInit {
  @Input()
  required: boolean;

  @Input()
  formLabel: string

  @Input()
  placeholder: string;

  @Input()
  formControlName: string;

  @Input()
  formGroup: FormGroup;

  suggestedStreetAddressOptions: google.maps.places.PlacePrediction[] = [];
  private sessionToken!: google.maps.places.AutocompleteSessionToken;

  @Output() didAutocompleteStreetAddress = new EventEmitter<google.maps.places.Place>();

  async ngOnInit(): Promise<void> {
	  await importLibrary("places") as google.maps.PlacesLibrary;
    this.sessionToken = new google.maps.places.AutocompleteSessionToken();

  }

  getFormControl(): FormControl {
	  return this.formGroup?.controls[this.formControlName ?? DEFAULT_STREET_ADDRESS_FORM_FIELD_NAME] as FormControl

  }

  ngAfterViewInit(): void {
	  this.getFormControl().valueChanges
      .pipe(
        debounceTime(DEFAULT_AUTOCOMPLETION_RESPONSE_TIME_IN_MS),
        switchMap(input => {
          if (!input || input.length < 2) {
            return of([]);

          }

          return this.fetchSuggestions(input);

        })

      )
      .subscribe((sugs: google.maps.places.PlacePrediction[]) => {
        this.suggestedStreetAddressOptions = sugs;

      });

  }

  private async fetchSuggestions(input: string): Promise<google.maps.places.PlacePrediction[]> {
    try {
      const request = {
        input,
        sessionToken: this.sessionToken,
		    includedRegionCodes: ['CA']

      };

      const { suggestions } =
        await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

      return suggestions.map(s => (s.placePrediction));

    } catch (err) {
      console.error('Autocomplete error:', err);
      return [];

    }

  }

  async onSuggestedAutocompleteOptionSelected(event: any) {
    const placeId = event.option.id;
    const selected = this.suggestedStreetAddressOptions.find(option => option.placeId === placeId);

    if (selected) {
      const placeRef = selected.toPlace();

      await placeRef.fetchFields({
		    fields: ['addressComponents']

      });

      this.didAutocompleteStreetAddress.emit(placeRef);

    }

  }

}
